export const REVIEW_CONTEXT = Object.freeze({
  applicants: "applicants",
  // TODO: Update everywhere to "for-approval" but it might be a little tricky since there is
  // stuff like state.reviewData[reviewType][`${contextType}s`].find(o => o.id == contextId)
  forApproval: "forApproval",
  requested: "requested",
});
